import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

import { AuthProvider, AuthContext } from './contexts/AuthContext';
import { ToastProvider, ToastContext } from './contexts/ToastContext';
import Main from './Main';
import Auth from './components/Auth';
import ErrorBoundary from './components/ErrorBoundary';
import DataTable from '@preflighttech/preflight-tables';
import './styles/styles.css';
import { MessageInputProvider } from './contexts/MessageInputContext';
import { UserProvider } from './contexts/UserContext';
import { BlogProvider } from './contexts/BlogContext';

const TABLE_STYLES = {
  header: {
    container: {
      textAlign: 'left',
      alignContext: null,
    },
  },
  data: {
    cell: {
      fontFamily: 'sans-serif',
      fontSize: 14,
    }
  },
};

const App = () => {
  const unsubscribe = '/unsubscribe' === window.location.pathname;

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <DataTable.Provider
          htmlTable
          styles={TABLE_STYLES}
        >
          <AuthProvider>
            <UserProvider>
              <ToastProvider>
                <BlogProvider>
                  <AuthContext.Consumer>
                    {ctx => (ctx.isLoggedIn && !unsubscribe) ? (
                      <MessageInputProvider>
                        <ErrorBoundary>
                          {ctx.apolloClient && <Main />}
                        </ErrorBoundary>
                      </MessageInputProvider>
                    ) : (
                      <ErrorBoundary>
                        <Auth />
                      </ErrorBoundary>
                    )}
                  </AuthContext.Consumer>

                  <Toaster style={{zIndex: 99999}} />
                </BlogProvider>
              </ToastProvider>
            </UserProvider>
          </AuthProvider>
        </DataTable.Provider>
      </ErrorBoundary>
    </HelmetProvider>
  );
};

export default App;
